export enum TableResultsOption {
	xs = 10,
	s = 25,
	m = 50,
	l = 100,
	xl = 200,
}